import { PiTextboxBold, PiTextAlignCenterFill, PiListDashesFill } from "react-icons/pi";
import { BsPlayBtn } from "react-icons/bs";
import { MdOutlineLightMode, MdDriveFolderUpload, MdOutlineWhatshot } from "react-icons/md";

import { GrStatusUnknown } from "react-icons/gr"

const ProcessDesignerToolbarModaltem = (props) => {

  //Props
  const Data = props.Data;
  const OnClickItem = props.OnClickItem;

  const onDisplayIcon = () => {

    switch (Data.code) {
      case "TextZone":
        return <PiTextAlignCenterFill />;
      case "TextInput":
        return <PiTextboxBold />;
      case "DropDown":
        return <PiListDashesFill />;
      case "ActionButton":
        return <BsPlayBtn />;
      case "LightCode":
        return <MdOutlineLightMode />;
      case "FileDownload":
        return <MdDriveFolderUpload  />;
      case "Superheat":
        return <MdOutlineWhatshot  />;
      default:
        return <GrStatusUnknown />;
    }

  };

  return (
    <div className="processdesigner_toolbar_component_item" onClick={() => OnClickItem(Data)}>
      <div className="processdesigner_toolbar_component_title">
        {Data.description}
      </div>
      <div className="processdesigner_toolbar_component_icon">
        {onDisplayIcon()}
      </div>
    </div>
  )
}

export default ProcessDesignerToolbarModaltem;